import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { SharingPublicThemeTariffsModalProps } from './SharingPublicThemeTariffsModal';

export const renderSharingPublicThemeTariffsModal = ({ onClose, ...data }: SharingPublicThemeTariffsModalProps) =>
    openPopupHelper({ popupName: popupNames.SHARING_PUBLIC_THEME_TARIFFS_MODAL, data, onClose });
